import React from 'react';

export default ({ children, title }) => (
    <section className="container">
        <h3>{title}</h3>
        <div className="px-custom">
            <div className="gallery-photo-video-embed w-100">

                <div className="gallery-bg-dark">
                    <div className="it-carousel-wrapper">
                        <div className="it-carousel-all it-img-card">
                            {children}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
);